export function Switch({ children }: any) {
  return children;
}

export default Switch;
